module.exports = __webpack_public_path__ + "img/any-num3.de62ea02.png";